module.exports = __webpack_public_path__ + "static/ubuntu-medium-e5613b0c875443174f948840c8ce07f6.woff";